// Placeholder page components for future implementation
// These will be replaced with full implementations in future milestones

import { Link } from 'react-router-dom';

export const AdminConsolePage = () => <div>Admin Console - Admin Only</div>;

/**
 * `/terms` and `/privacy` are still one-line stubs, but they are reachable and
 * linked to — the sign-up page links to both. They used to have a way out by
 * accident: the mobile nav rendered for anyone signed in, so Home bounced you
 * somewhere. #1867 hides that nav for users who cannot use it, which would have
 * left these pages with nothing but the browser back button. Same shape as the
 * 404 below, so the same treatment.
 */
export const StubPage = ({ title }: { title: string }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div className="text-center">
      <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
      <p className="mt-2 text-sm text-gray-600">
        This page has not been written yet.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block font-medium text-sky-600 hover:text-sky-500 transition-colors duration-200"
      >
        Go to the home page
      </Link>
    </div>
  </div>
);

/**
 * The 404 needs a way out, because it is where every broken link in the app
 * deposits people. (`PricingPage`'s "View FAQ" → `/faq` was the live example
 * when this was written; it has since been removed.)
 *
 * Reproduced during #1867: an unverified user following "Update your email"
 * landed here, on a page whose entire content was the words "404 - Page Not
 * Found". No link, no chrome — `AppLayout` is a passthrough, and `MobileNav`
 * renders nothing for them. Stranded a second time by the page that exists to
 * catch that.
 */
export const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div className="text-center">
      <h1 className="text-2xl font-semibold text-gray-900">
        404 - Page Not Found
      </h1>
      <p className="mt-2 text-sm text-gray-600">
        That page does not exist. If you followed a link from within Heapster
        ID, it is our mistake rather than yours — please{' '}
        <Link
          to="/contact"
          className="font-medium text-sky-600 hover:text-sky-500 transition-colors duration-200"
        >
          tell us
        </Link>
        .
      </p>
      <Link
        to="/"
        className="mt-6 inline-block font-medium text-sky-600 hover:text-sky-500 transition-colors duration-200"
      >
        Go to the home page
      </Link>
    </div>
  </div>
);
